<template>
  <v-container fluid class="pa-0 ma-0">
    <v-row>
      <v-col>
        <v-card outlined class="px-4 ma-2">
          <v-card-title class="pa-0 my-4">Supported languages</v-card-title>
          <p>Check languages you want your project to support</p>
          <v-row v-for="lang in langList" :key="lang.id">
            <v-checkbox
              v-model="projectSettings.selectedLangs"
              :label="lang.name"
              :value="lang.id"
              :disabled="
                projectSettings.selectedLangs.length == 1 &&
                  lang.id == projectSettings.selectedLangs[0]
              "
              color="primary"
              @change="selectDefaultLang(), updateChangeDetected(true)"
            ></v-checkbox>
          </v-row>

          <v-select
            :items="langOptions"
            item-text="name"
            item-value="id"
            label="Default language"
            outlined
            @change="updateChangeDetected(true)"
            v-model="projectSettings.defaultLangId"
            :menu-props="{ top: false, offsetY: true }"
            style="max-width: 300px"
            class="mx-0 mb-3"
            hide-details="auto"
          ></v-select>
        </v-card>
      </v-col>

      <v-col>
        <v-card outlined class="px-4 ma-2">
          <v-card-title class="pa-0 my-4">Supported filters</v-card-title>
          <p>Check filters you want your project to support</p>
          <v-row v-for="filter in filterList" :key="filter.id">
            <v-checkbox
              :class="filter.name"
              v-model="projectSettings.selectedFilters"
              :label="filter.name"
              :value="filter.id"
              color="primary"
              @change="
                selectDefaultLang(),
                  updateChangeDetected(true, projectSettings.selectedFilters)
              "
            ></v-checkbox>
            <ul
              class="project-settings-roles-wrapper"
              v-if="filter.name === 'Price'"
            >
              <li
                class="project-settings-roles"
                v-for="role in roleList"
                :key="role.id"
              >
                <v-checkbox
                  v-model="projectSettings.selectedRoles"
                  :label="role.name"
                  :value="role.id"
                  color="primary"
                  @change="selectDefaultLang(), updateChangeDetected(true)"
                  :disabled="disablePrice"
                ></v-checkbox>
              </li>
            </ul>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-card-actions class="justify-end">
      <v-btn small :disabled="!changeDetected" @click="cancel()"
        >Discard Changes</v-btn
      >
      <v-btn
        small
        :disabled="!changeDetected"
        color="primary darken-1"
        @click="saveSettingsDialog()"
        >Save</v-btn
      >
    </v-card-actions>
  </v-container>
</template>

<script>
import Enums from '../helpers/Enums'
import { EventBus } from '../helpers/Events'

export default {
  props: {
    currentTab: {
      required: false,
      type: String
    }
  },
  data: function() {
    this.langList = Enums.lang
    this.filterList = Enums.filters
    this.roleList = Enums.roles
    this.defaultLangOptions = []
    return {
      projectSettings: {
        projectId: this.$route.params.projectId,
        selectedLangs: [],
        selectedFilters: [],
        selectedRoles: [],
        defaultLangId: 1
      },
      changeDetected: false,
      disablePrice: false
    }
  },
  methods: {
    updateChangeDetected(val, selectedFilters) {
      if (selectedFilters) {
        this.priceCheckboxState(selectedFilters)
      }
      this.changeDetected = val
      this.$emit('changeDetectedSettings', val)
    },
    saveSettingsDialog() {
      this.$store.dispatch('DialogStore/open', {
        title: 'Save changes',
        header: false,
        subtitle: 'Are you sure?',
        okText: 'Ok',
        ok: () => {
          this.SaveSettings()
        },
        cancelText: 'Cancel'
      })
    },
    async SaveSettings() {
      await this.$store.dispatch(
        'ProjectStore/setSelectedProjectSettings',
        this.projectSettings
      )
      this.cancel()
      this.dialog = false
    },
    async cancel() {
      await this.$store.dispatch(
        'ProjectStore/getSelectedProjectSettings',
        this.$route.params.projectId
      )
      this.getProjectConfig()
      this.updateChangeDetected(false)
    },
    priceCheckboxState(selectedFilters) {
      var filters = []
      for (const [propertyKey, propertyValue] of Object.entries(
        Enums.filters
      )) {
        if (propertyValue.name !== 'Price') continue
        filters.push({ propertyKey, propertyValue })
      }
      if (selectedFilters.includes(filters[0].propertyValue.id)) {
        this.disablePrice = false
      } else {
        this.disablePrice = true
      }
    },
    getProjectConfig() {
      this.projectSettings.selectedLangs = this.projectConfig[
        this.projectConfig.length - 1
      ].mediaData.selectedLangs
      const filters = this.projectConfig[this.projectConfig.length - 1]
        .mediaData.selectedFilters
      if (!filters) {
        this.projectSettings.selectedFilters = Object.keys(Enums.filters).map(
          f => Number(f)
        )
        this.SaveSettings()
      }
      this.projectSettings.selectedFilters = filters
      const roles = this.projectConfig[this.projectConfig.length - 1].mediaData
        .selectedRoles
      if (!roles) {
        this.projectSettings.selectedRoles = Object.keys(Enums.roles).map(f =>
          Number(f)
        )
        this.SaveSettings()
      }
      this.projectSettings.selectedRoles = roles
      this.projectSettings.defaultLangId = this.projectConfig[
        this.projectConfig.length - 1
      ].mediaData.defaultLangId
      this.priceCheckboxState(this.projectSettings.selectedFilters)
      this.selectDefaultLang()
    },
    selectDefaultLang() {
      if (
        !this.projectSettings.selectedLangs.includes(
          this.projectSettings.defaultLangId
        )
      ) {
        this.projectSettings.defaultLangId = this.projectSettings.selectedLangs[0]
      }
    }
  },

  mounted() {
    this.getProjectConfig()
    EventBus.$on('saveSettings', this.SaveSettings)
  },
  destroyed() {
    EventBus.$off('saveSettings')
  },
  computed: {
    langOptions() {
      let arr = []
      Object.entries(this.langList).forEach(([key, value]) => {
        if (this.projectSettings.selectedLangs.includes(value.id)) {
          arr.push(value)
        }
      })
      return arr
    },
    projectConfig() {
      return this.$store.state.ProjectStore.projectConfig
    }
  },
  watch: {
    currentTab: function(newVal, oldVal) {
      if (oldVal === 'projectSettings') {
        this.cancel()
      }
    }
  }
}
</script>

<style scoped>
.project-settings-roles-wrapper {
  padding: 0px;
}
.project-settings-roles {
  display: inline-block;
  padding-right: 10px;
}
.Price {
  margin-right: 10px;
}
</style>
